<template>
  <div class="view-container">
    <form id="finalize" class="payment-result-form">
      <app-loaderForm :display="'block'" ref="LoaderForm"></app-loaderForm>
    </form>
  </div>
</template>
<!-- Scripts -->
<script>
import LoaderForm from '../../components/LoaderForm.vue';
export default {
  name: 'Finalize',
  components: {
    'app-loaderForm': LoaderForm,
  },
  data() {},
};
</script>
